import{configureStore} from "@reduxjs/toolkit";
import postsReducer from "../features/posts/postsSlice";
import postReducer from "../features/post/postSlice";
import filterReducer from "../features/filter/filterSlice";
import relatedPostsReducer from "../features/relatedPosts/relatedPostsSlice";
export const store = configureStore({
    reducer: {
        posts: postsReducer,
        post: postReducer,
        relatedPosts: relatedPostsReducer,
        filter: filterReducer,
    }
});